import styled from "styled-components";

const TabsWrapper = styled.div`
  // Tabs component
  .tabs {
    width: 100%;

    &__list {
      display: block;
      width: 100%;
      border-bottom: 2px solid #dfe2e3;
      padding: 0;
      list-style: none;
    }

    &__tab {
      display: inline-block;
    }

    &__tab-link {
      display: inline-block;
      text-align: center;
      padding: 6px 30px 8px 30px;
      color: #1874b9;
      border-bottom: 4px solid transparent;
      cursor: pointer;
      text-decoration: none !important;

      &--active {
        color: #1874b9;
        font-weight: 700;
        border-color: #1874b9;
      }
    }

    &__content {
      margin: 30px auto;
      width: 100%;
    }
  }
`;

export default TabsWrapper;
